import { apiGet } from "../standardApi";

export async function apiGetFAQ() {
    const response = await apiGet(`/FaqTheme/InfosFaqThemes`, 'application/json');
    return response;
  }